(function() {
    'use strict';

    angular
        .module('gwApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
